import { render, staticRenderFns } from "./catCoOrgan.vue?vue&type=template&id=2d73b8ba&scoped=true"
import script from "./catCoOrgan.vue?vue&type=script&lang=js"
export * from "./catCoOrgan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d73b8ba",
  null
  
)

export default component.exports